import {  SlotGameType1_3 } from "../SlotGameType1_3";
export class IcyManiaDeluxClassic3 extends SlotGameType1_3{}